componentRegistryInstance.register('obfuscated', 'edit', 'hrd.components.form.ObfuscatedComponent');
componentRegistryInstance.register('obfuscated', 'read', 'hrd.components.form.ObfuscatedComponent');

hrd.components.form.ObfuscatedComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.ObfuscatedComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceEditField: function(field, id, klass) {
		this._super(field, id, klass);
		field.prop('type', 'text');
		field.addClass('dots-only-field');
		if(field.data('showEye') == true){
			var eye = $('<span class="f-icon far fa-eye-slash ignore-for-fhs ignore-aw"></span>');
			eye.css({
				marginLeft: '5px',
				color: '#ff0000',
				fontSize: 'larger',
				cursor: 'pointer'
			});
			field.after(eye);
			eye.off('.eye').on('click.eye', evt => {
				if(field.hasClass('dots-only-field')){
					field.removeClass('dots-only-field');
					eye.removeClass('fa-eye-slash').addClass('fa-eye').css('color', '#099909');
				} else {
					field.addClass('dots-only-field');
					eye.removeClass('fa-eye').addClass('fa-eye-slash').css('color', '#ff0000');
				}
			});
		}
	},
	enhanceReadField: function(field, id, klass) {
		this._super(field, id, klass);
		field.addClass('dots-only-field');
	}
});